import {
  ClinicRoleModel,
  IClinicRoleModel,
} from '@common/models/ClinicRoleModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class ClinicRoleService {
  private static baseUrl: string = '/api/clinicrole/';
  static tags = {
    upsertClinicRole: 'upsertClinicRole',
    deleteClinicRole: 'deleteClinicRole',
  };

  static upsertClinicRole = (
    data: IClinicRoleModel,
  ): Promise<ClinicRoleModel> => {
    return trackPromise(
      new Promise<ClinicRoleModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IClinicRoleModel>(data)
          .then((response) => {
            resolve(new ClinicRoleModel(response));
          })
          .catch(reject);
      }),
      this.tags.upsertClinicRole,
    );
  };

  static deleteClinicRole = (clinicRoleId: number): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}${clinicRoleId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch(reject);
      }),
      this.tags.deleteClinicRole,
    );
  };
}
